module.exports = __webpack_public_path__ + "img/dan3.bdcd7a75.png";